import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgCarService
    ,FvmsApiDtgDangerDriveService
    ,FvmsApiAuthService
} from "src/app/shared";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";

@Component({
    selector: "dtg-manage-danger-drive-rule-list"
    ,templateUrl: './dtg.manage.danger.drive.rule.list.component.html'
    ,styleUrls: ["./dtg.manage.danger.drive.rule.list.component.scss"]
})
export class DtgManageDangerDriveRuleListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    subtitle: string;
    currentUserInfo:any;
    companyInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    userGroupId:number = null;
    dtgTeamId:string = "";
    listCarType:any[];
    listRuleType:any[];
    listRuleConfig:any[];
    selectedCarType:string = "0";
    selectedRuleType:number = 0;
    @Input() listType:DtgListType = DtgListType.list;
    @Output() driveRuleInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;

    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private fvmsApiDtgDangerDriveService:FvmsApiDtgDangerDriveService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;
    }

    ngOnInit() {
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.companyId !== companyInfo.companyId){
                        this.companyInfo = companyInfo;
                    }
                }else{
                    this.companyInfo = companyInfo;
                }
                this.pagingInfo.curPage = 1;
                this.reloadAll();
            });
        
        this.reloadAll();
        this.reloadListCarType();
        this.reloadListRuleType();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadAll(){
        this.reloadListRuleConfig();
    }

    reloadListCarType(){
        this.fvmsApiDtgCarService.getListCarType(null)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listCarType = apiResponse.resultValue;
                }
            });
    }

    reloadListRuleType(){
        this.fvmsApiDtgDangerDriveService.getListRuleType(null)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listRuleType = apiResponse.resultValue;
                }
            });
    }

    reloadListRuleConfig(){
        let searchInfo = {
            "companyId":this.companyInfo.companyId || "1"
            ,"dtgDriveRuleType":this.selectedRuleType
            ,"dtgCarType":this.selectedCarType
        };
        this.fvmsApiDtgDangerDriveService.getListRuleConfig(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listRuleConfig = apiResponse.resultValue;
                }
            });
    }

    changeCarType(e){
        this.reloadListRuleConfig();
    }

    changeRuleType(e){
        this.reloadListRuleConfig();
    }

    clickOpenModalDriveRuleInfo(dtgActionType:DtgActionType,userInfo:any){
        // let modalRef = this.modalService.open(
        //     DtgManageUserFormComponent
        //     ,{
        //         centered:true
        //         // ,size: "xl"
        //         ,backdrop:"static"
        //         //windowClass: "dark-modal"
        //         ,scrollable: true
        //     }
        // );
        // modalRef.componentInstance.dtgActionType = dtgActionType;
        // modalRef.componentInstance.companyId = userInfo?.companyId || this.companyInfo.companyId;
        // modalRef.componentInstance.userId = userInfo?.userId;

        // modalRef.result.then((resultModal) => {
        //     switch(dtgActionType){
        //         case DtgActionType.create:
        //         case DtgActionType.update:
        //         case DtgActionType.delete:
        //             if(resultModal.result === "ok"){
        //                 this.clickSearch();
        //             }
        //             break;
        //         default:
        //             break;
        //     }
        // });
    }
}